import React from "react";
import { Link } from "react-router-dom";
import siteConfig from "../config/siteConfig";
import "../css/terms.scss";

function Terms() {
  return (
    <main className="policy-page terms" aria-labelledby="terms-title">
      <header className="policy-page__intro">
        <div className="policy-page__intro-inner">
          <p className="policy-page__kicker">Customer care / Legal</p>
          <h1 id="terms-title">Terms &amp; conditions</h1>
          <p className="policy-page__lead">
            The practical terms that apply when you browse or place an order with{" "}
            {siteConfig.brandName}.
          </p>
          <p className="policy-page__updated">Last updated 15 August 2026</p>
        </div>
      </header>

      <div className="policy-page__layout">
        <nav className="policy-page__contents" aria-label="Terms and conditions contents">
          <p>On this page</p>
          <a href="#terms-scope">Using this site</a>
          <a href="#terms-products">Products and pricing</a>
          <a href="#terms-orders">Orders and payment</a>
          <a href="#terms-delivery">Delivery and returns</a>
          <a href="#terms-liability">Responsibility</a>
          <a href="#terms-contact">Contact us</a>
        </nav>

        <article className="policy-page__content">
          <section id="terms-scope">
            <p className="policy-page__section-number">01</p>
            <h2>Using this site</h2>
            <p>
              By using this website, you agree to these terms and to use the site
              lawfully. Content is provided for personal shopping and product
              research; it may not be copied, resold or misused without permission.
            </p>
          </section>

          <section id="terms-products">
            <p className="policy-page__section-number">02</p>
            <h2>Products, availability and pricing</h2>
            <p>
              We work to describe products and colours accurately, but screens and
              natural materials can vary. Availability is not guaranteed until an
              order is accepted. Prices and promotions may change, but confirmed
              orders will not be altered except to correct an obvious error with
              your agreement.
            </p>
          </section>

          <section id="terms-orders">
            <p className="policy-page__section-number">03</p>
            <h2>Orders and payment</h2>
            <p>
              An order acknowledgement confirms that we have received your request;
              a contract is formed when the order is accepted for dispatch. We may
              decline or cancel an order where stock, payment, pricing or fraud
              checks prevent fulfilment, and will refund any captured payment.
            </p>
          </section>

          <section id="terms-delivery">
            <p className="policy-page__section-number">04</p>
            <h2>Delivery, cancellations and returns</h2>
            <p>
              Delivery dates are estimates and can be affected by carriers or
              customs. Please check our <Link to="/shipping">shipping guide</Link>{" "}
              and <Link to="/returns">returns policy</Link> for current processes,
              eligibility and timing.
            </p>
          </section>

          <section id="terms-liability">
            <p className="policy-page__section-number">05</p>
            <h2>Our responsibility</h2>
            <p>
              Nothing in these terms limits rights that cannot lawfully be limited.
              To the extent permitted by law, we are not responsible for indirect
              losses or failures caused by events beyond reasonable control. Care
              instructions must be followed to preserve product performance.
            </p>
          </section>

          <section id="terms-contact" className="policy-page__callout">
            <p className="policy-page__section-number">06</p>
            <h2>Need clarification?</h2>
            <p>
              Email <a href={`mailto:${siteConfig.contact.email}`}>{siteConfig.contact.email}</a>{" "}
              before ordering and our team will be glad to help.
            </p>
          </section>
        </article>
      </div>
    </main>
  );
}

export default Terms;
